




































import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import { Button, Icon, Toast } from '@descomplica/vue-components';
import Analytics from '@/helpers/analytics';
import { downloadBase64File } from '@/helpers/download';
import pipeline from '@/pipeline';
import LoadingPage from '@/components/LoadingPage.vue';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import { PaymentInfoTrackingModel } from '@/helpers/paymentInfoTracking';

export default Vue.extend({
  components: {
    VueMarkdown,
    Button,
    Icon,
    LoadingPage,
    Toast,
  },
  props: {
    paymentInfoTracking: {
      type: Object as () => PaymentInfoTrackingModel,
      required: true,
    },
    studentEmail: {
      type: String,
      default: '',
    },
  },
  data() {
    return { isLoading: false, error: false };
  },
  computed: {
    studentAcademicRecord(): string {
      return this.$store.getters.backofficeStudentAcademicRecord;
    },
  },
  methods: {
    downloadBankSlipFile() {
      const { bankSlipFile } = this.$store.getters;

      downloadBase64File(bankSlipFile, 'boleto-descomplica.pdf', 'application/pdf');
    },
    async finishHandler() {
      try {
        this.isLoading = true;
        await this.$store.dispatch('GENERATE_BANK_SLIP');

        this.downloadBankSlipFile();

        await this.$store.dispatch('GET_ENROLLMENT');

        await this.$store.dispatch(AnalyticsActions.PAYMENT_SENT, {
          academicRecordId: this.studentAcademicRecord,
          paymentMethod: 'Boleto',
          ...this.paymentInfoTracking,
        });

        const { enrollmentId, course, enrollmentStatus } = this.$store.getters;

        if (enrollmentStatus === 'pendingPayment')
          Analytics.trackEcommerceTransaction(enrollmentId, course, {
            academicRecordId: this.studentAcademicRecord,
            paymentMethod: 'Boleto',
            email: this.studentEmail,
            ...this.paymentInfoTracking,
          });

        pipeline.next({ status: enrollmentStatus });
      } catch (err) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
